module.exports = __webpack_public_path__ + "media/images/edad-logo-002d63a5fda86f05f756c21feafab70f.png";